"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroDoubleWithMediaExtended = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const double_with_media_1 = require("@ariessolutionsio/react-ecomm-ui/dist/components/PageSections/marketing/hero-sections/double-with-media");
const HeroDoubleWithMediaExtended = (props) => {
    const { extendedClasses } = props;
    const ctaLabelStyle = extendedClasses?.ctaLabel || '';
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex w-full justify-center", children: (0, jsx_runtime_1.jsx)(double_with_media_1.HeroDoubleWithMedia, { ...props, extendedClasses: {
                title: 'text-[52px] leading-[52px] font-bold text-white',
                contentBox: 'px-4 py-4 md:px-16 w-full text-left',
                mediaHeight: 'md:h-[384px] lg:h-[680px]',
                eyebrow: 'text-[40px] font-normal leading-[52px]',
                description: 'font-normal text-[16px] leading-[25.6px]',
                ctaLabel: ctaLabelStyle,
            } }) }));
};
exports.HeroDoubleWithMediaExtended = HeroDoubleWithMediaExtended;
